import { useSelector } from 'react-redux';

import { TProductCategory } from '@lib/core/products/types';
import {
  selectActiveFidelityModalCode,
  selectFidelityCardData,
  selectIsFidelityCardScanLoading,
} from '@lib/core/users/selectors/fidelityCard';
import { handleFidelityCodeThunk } from '@lib/core/users/slices/fidelityCard';
import { useTypedDispatch } from '@lib/tools/views/hooks/useTypedDispatch';

const useFidelityCard = () => {
  const dispatch = useTypedDispatch();

  const isFidelityCardLoading = useSelector(selectIsFidelityCardScanLoading);
  const fidelityCardData = useSelector(selectFidelityCardData);
  const activeFidelityModalCode = useSelector(selectActiveFidelityModalCode);
  const { card_identifier: fidelityCardId } = fidelityCardData || {};

  const handleFidelityCode = (fidelityCardCode: string, productCategory: TProductCategory) =>
    dispatch(
      handleFidelityCodeThunk({
        fidelityCardCode,
        productCategory,
      }),
    );

  return {
    activeFidelityModalCode,
    fidelityCardData,
    fidelityCardId,
    handleFidelityCode,
    isFidelityCardLoading,
    isFidelityCardScanned: !!fidelityCardId,
  };
};

export { useFidelityCard };
